<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :row-class-name="rowClassName"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="waybillDetailCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:orderStatus="{row}">
        <el-tag
          size="mini"
          :type="
            row.orderStatus === 'N'
              ? 'success'
              : row.orderStatus === 'Y'
              ? 'light'
              : 'warning'
          "
        >
          {{ row.orderStatusName }}
        </el-tag>
      </template>
      <template v-slot:opt="{row}">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看回单"
            placement="top"
          >
            <i
              class="el-icon-picture-outline tool-btn"
              @click="viewPodImage(row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:orderNo="{row}">
        <div>
          <el-link type="primary" @click="openOrderDetailPage(row.orderNo)">
            {{ row.orderNo }}
          </el-link>
        </div>
      </template>
    </vxe-grid>
    <div v-show="false" class="images" v-viewer="{movable: true}">
      <img
        v-for="(item, index) in imageList"
        :src="$osscdn(item.imageUrl) || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      previewDialogOptions: {
        viewVisible: false,
        code: '',
      },
      tableColumns: tableColumns(),
      selectList: [],
      fullScreenLoading: false,
      imageList: [],
      rowClassName: ({row}) => {
        if (row.v_isAbnormal === '异常') {
          return 'bg-danger text-white'
        }
        return ''
      },
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 242
    },
    openEditPage({pageType, code}) {
      this.$router.push({
        name: 'carriage-order-detail',
        params: {orderCode: code, pageType},
      })
    },
    viewPodImage(row) {
      this.fullScreenLoading = true
      let params = {
        linkBillType: 'C',
        dispatchOrderCode: row.dispatchOrderCode,
      }
      this.$api
        .carriageWaybillimgListApi(params)
        .then((res) => {
          this.fullScreenLoading = false
          this.imageList = res.body.data
          this.imageView()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    imageView() {
      // 点击大图显示图片预览组件
      if (this.imageList.length > 0) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    },
    openOrderDetailPage(no) {
      this.$router.push({
        name: 'carriage-order-detail-page',
        params: {no},
      })
    },
  },
}
</script>
